import React from "react";
import MiniGLBViewer from "../pages/Spaceship";
import WaveformVisualizer from "./WaveformVisualizer";   // ★ 声音波形背景

export default function AngelWrapper({ children }) {
  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* —— Ocean 背景层 —— */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <style>{`
          .sketchfab-embed-wrapper {
            position: fixed !important;
            top: 0 !important; left: 0 !important;
            width: 100vw !important; height: 100vh !important;
            pointer-events: none !important; z-index: 0 !important;
          }
          .sketchfab-embed-wrapper > iframe {
            position: absolute !important;
            top: 50% !important; left: 50% !important;
            transform: translate(-50%, -50%) scale(1.2) !important;
            min-width: 120% !important; min-height: 120% !important;
            pointer-events: auto !important;
          }
        `}</style>
        <div className="sketchfab-embed-wrapper">
          <iframe
            title="ocean"
            frameBorder="0"
            allow="autoplay; fullscreen; xr-spatial-tracking"
            src="https://sketchfab.com/models/56112ae2e55e45a4951362b323540349/embed?autostart=1&camera=0"
          />
        </div>
      </div>

      {/* —— 全屏音频波形背景 —— */}
      <WaveformVisualizer opacity={0.6} blend="screen" />

      
      {/* —— UI 层 —— */}
      <div
        style={{
          position: "relative",
          zIndex: 100,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      >
        {children}
      </div>
    </div>
  );
}
